// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__29yAG","requiredAsterisk":"Info_requiredAsterisk__ZxHVu"};